export const effects = {
  thin: {
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)',
  },
  light: {
    boxShadow: '0px 8px 24px 0px rgba(153, 153, 153, 0.2)',
  },
  smooth: {
    boxShadow: '0px 48px 100px 0px rgba(51, 51, 51, 0.15)',
  },
  heavy: {
    boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.35)',
  },
  intense: {
    boxShadow: '0px 19px 38px 0px rgba(0, 0, 0, 0.3), 0px 15px 12px 0px rgba(0, 0, 0, 0.22)',
  },
  tabBar: {
    boxShadow: '0px 32px 100px 0px rgba(51, 51, 51, 0.15)',
  },
  sectionElevation: {
    boxShadow: '0px 0px 24px 0px rgba(153, 153, 153, 0.12)',
  },
  reviewElevation: {
    boxShadow: '0px -8px 24px 0px rgba(153, 153, 153, 0.12)',
  },
}
